import { render } from "./assign.vue?vue&type=template&id=1970a94c"
import script from "./assign.vue?vue&type=script&lang=js"
export * from "./assign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__